import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("LGE Admin")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "LGE Admin", -1)
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, " Enabling swaps will make it possible for users to buy and sell your token. We recommend that you enable swaps right as the price decay begins and disable swaps right as the price decay ends. ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Disable Swaps ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Enable Swaps ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 mt-12" }, " Exiting the pool will burn your BPT and return all pool funds to your wallet. You should only exit the pool after the LGE has come to an end. ", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Exit Pool ")

import { TransactionReceipt } from '@ethersproject/providers';
import { computed, ref, watch } from 'vue';
import useWeb3 from '@/services/web3/useWeb3';
import useTransactions from '@/composables/useTransactions';
import useEthers from '@/composables/useEthers';
import { CopperProxyService } from '@/embr/services/pool/copper-proxy.service';
import { GqlLge } from '@/embr/services/embr/embr-types';
import { FullPool } from '@/services/balancer/subgraph/types';
import BalBtn from '@/components/_global/BalBtn/BalBtn.vue';
import BalModal from '@/components/_global/BalModal/BalModal.vue';
import BalToggle from '@/components/_global/BalToggle/BalToggle.vue';
import useLge from '@/embr/lbp/composables/useLge';

type Props = {
  lge: GqlLge;
  pool: FullPool;
};


export default _defineComponent({
  props: {
    lge: { type: null, required: true },
    pool: { type: null, required: true }
  } as unknown as undefined,
  emits: ["adminEvent"] as unknown as undefined,
  setup(__props: {
  lge: GqlLge;
  pool: FullPool;
}, { emit }: { emit: ({
  (e: 'adminEvent'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const { appNetworkConfig, getProvider, account } = useWeb3();
const { addTransaction } = useTransactions();
const { txListener } = useEthers();

const modalOpen = ref(false);
const copperProxyService = computed(
  () => new CopperProxyService(appNetworkConfig.key)
);

const poolExited = computed(
  () => parseFloat(props.pool.totalShares) < 0.00000001
);

const togglingSwapsEnabled = ref(false);
const exitingPool = ref(false);

const { onNewTx } = useLge(props.lge, props.pool);

async function toggleSwaps(enable: boolean): Promise<void> {
  try {
    togglingSwapsEnabled.value = true;

    const tx = await copperProxyService.value.setSwapEnabled(
      getProvider(),
      props.lge.address,
      enable
    );

    addTransaction({
      id: tx.hash,
      type: 'tx',
      action: 'trade',
      summary: `${enable ? 'Enabling' : 'Disabling'} swaps for your LBP`
    });

    txListener(tx, {
      onTxConfirmed: async () => {
        togglingSwapsEnabled.value = false;
        onNewTx();
        emit('adminEvent');
      },
      onTxFailed: () => {
        togglingSwapsEnabled.value = false;
      }
    });
  } catch (error) {
    console.error(error);
    togglingSwapsEnabled.value = false;
  }
}

async function exitPool(): Promise<void> {
  try {
    exitingPool.value = true;

    const tx = await copperProxyService.value.exitPool(
      getProvider(),
      props.lge.address
    );

    addTransaction({
      id: tx.hash,
      type: 'tx',
      action: 'withdraw',
      summary: 'Withdrawing all assets from your LBP'
    });

    txListener(tx, {
      onTxConfirmed: async () => {
        exitingPool.value = false;
        onNewTx();
        emit('adminEvent');
      },
      onTxFailed: () => {
        exitingPool.value = false;
      }
    });
  } catch (error) {
    console.error(error);
    exitingPool.value = false;
  }
}

function closeModal() {
  modalOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BalBtn, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modalOpen.value = true))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(BalModal, {
      show: modalOpen.value,
      onClose: closeModal
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (props.pool.swapEnabled)
            ? (_openBlock(), _createBlock(BalBtn, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSwaps(false))),
                loading: togglingSwapsEnabled.value,
                "loading-label": "Disabling..."
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"]))
            : (_openBlock(), _createBlock(BalBtn, {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSwaps(true))),
                loading: togglingSwapsEnabled.value,
                "loading-label": "Enabling..."
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["loading"]))
        ]),
        _hoisted_7,
        _createVNode(BalBtn, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (exitPool())),
          color: "red",
          loading: exitingPool.value,
          "loading-label": "Exiting...",
          class: "mb-4",
          disabled: _unref(poolExited)
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})